import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeTop16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconEdgeTop16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.555 5.058a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m1.5-3.113a.5.5 0 0 0 0 1h6a.5.5 0 1 0 0-1zm3.75 11.363a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-3.5-.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m8.003-8.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m-9.753 3.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m9.753-.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m-9.753 3.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m9.753-.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m-1.753 3a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeTop16);
